import { Heading, HStack, VStack } from '@/components/Atoms'
import { PageError } from '@/components/PageError'
import { PageLoader } from '@/components/PageLoader'
import { AuditTrail } from '@/hooks/queries/useAuditTrails'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@repo/ui/components'
import { useTranslation } from 'react-i18next'
import { AuditTrailDetailsContent } from './AuditTrailDetailsContent'
import { AuditTrailDetailsHeader } from './AuditTrailDetailsHeader'
import { AuditTrailS3DownloadButton } from './AuditTrailS3DownloadButton'

type AuditDetailsSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  isPending: boolean
  auditTrail: AuditTrail | undefined
  error: Error | null
}

function AuditDetailsSheet(props: AuditDetailsSheetProps) {
  const { t } = useTranslation('admin')
  const title = t('auditDetailsSheet.title')

  if (props.isPending) {
    return (
      <Sheet open={props.open} onOpenChange={props.onOpenChange}>
        <SheetContent aria-label={title}>
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
          </SheetHeader>
          <PageLoader global />
        </SheetContent>
      </Sheet>
    )
  }

  if (props.error) {
    return (
      <Sheet open={props.open} onOpenChange={props.onOpenChange}>
        <SheetContent aria-label={title}>
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
          </SheetHeader>
          <PageError message={props.error.message} global />
        </SheetContent>
      </Sheet>
    )
  }

  if (!props.auditTrail) {
    return null
  }

  return (
    <Sheet open={props.open} onOpenChange={props.onOpenChange}>
      <SheetContent aria-label={title}>
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>

        <VStack gap="lg" className="px-6 py-8">
          <HStack gap="sm" className="w-full justify-between">
            <Heading level={3}>{t(`eventTypes.${props.auditTrail.eventType}`)}</Heading>

            <AuditTrailS3DownloadButton auditTrail={props.auditTrail} />
          </HStack>

          <AuditTrailDetailsHeader auditTrail={props.auditTrail} />

          <AuditTrailDetailsContent auditTrail={props.auditTrail} />
        </VStack>
      </SheetContent>
    </Sheet>
  )
}

export default AuditDetailsSheet
